import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
function Root() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.fbq) return;
    // Meta Pixel — safe injection (appends to <head> instead of relying on existing <script>)
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    w.fbq = n;
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    (document.head || document.body || document.documentElement).appendChild(t);
    w.fbq('init', '790333870788238');
    w.fbq('track', 'PageView');
  }, []);
  return <App data-id="element-393" />;
}
render(<Root data-id="element-394" />, document.getElementById('root'));